// eslint-disable-next-line import/no-anonymous-default-export
export default {
  license: {
    common: {
      name: "License",
      licenseType: "Type of Permit Application",
      contractId: "Contract Number",
      licensedTo: "Customer ID",
      licensedToCompanyName: "Customer Name",
      fromTo: "License Period",
      machineKey: "Machine Code",
      requestedBy: "Requested By",
      createBy: "Create By",
      issuanceTime: "Issuance Time",
      createdAt: "Importing Time",
      requestAt: "Application Time",
      userImported: "User Imported",
      lastIssuanceTime: "Last Issuance Time",
      countsOfApplication: "Counts Of Application",
      notExpired: "Not expired quantity",
      total: "Total",
      applySource: "Apply Source",
      platformToCreate: "Platform To Create",
      dingTalkApproval: "DingTalk Approval",
      purchaseOnline: "Purchase Online",
      issueSuccessfully: "Issue successfully",
      issueFailed: "Issue Failed",
      copyLicense: "Copy License",
      licenseInformation: "License Information",
      purposeOfApplication: "Purpose Of Application",
      deploymentWay: "Deployment Way",
      trial: "Trial",
      formal: "Formal",
      test: "Test",
      saasVersion: "SaaS Version",
      allManaged: "All Managed",
      privatization: "Privatization Deployment",
      systemAccount: "System Account",
      all: "All",
      sevenDayExpire: "Expiration within seven days",
      oneMonthExpire: "Expiration within one month",
      threeMonthExpire: "Expiration within three months",
      expired: "Expired",
      validity: "License Period",
      existingCompany:
        "Existing Company (Including enterprise wechat integration)",
      activateSuccessfully: "Activate Successfully",
      activateFailed: "Activate Failed",
      export: "Export (First 200 entries)",
      notice: "Email notification (Email)",
      localOcr: "Local OCR",
    },
    console: {
      numStudio: "Number of Enterprise Edition Editors",
      numFloatingStudio: "Number of Floating Authorization Editors",
      numBasicRobot: "Number of Enterprise Basic Robots",
      numPremiumRobot: "Number of Enterprise Advanced Edition Robots",
      numFloatingRobot: "Number of Floating Authorization Robots",
      numApp: "Number of Enterprise Workstations",
      numPdfImage: "Documentation Understands API Quotas (Pdf Image)",
      numPdfText: "Documentation Understands API Quotas (Pdf Text)",
      numVicode: "ViCode",
    },
    validate: {
      contractId: "Please enter contract number",
      licensedTo: "Please enter consumer ID",
      licensedToCompanyName: "Please enter customer name",
      purposeOfApplication: "Please select purpose of application",
      validity: "Please select license period",
      licenseType: "Please select the type of Permit Application",
      fromTo: "Please select license period",
      machineKey: "Please enter the machine code",
      numStudio: "Please enter the number of enterprise edition editors",
      numFloatingStudio:
        "Please enter the number of floating authorization editors",
      numBasicRobot:
        "Please enter the number of enterprise basic version robots",
      numPremiumRobot:
        "Please enter the number of enterprise advanced version robots",
      numFloatingRobot: "Please enter the number of floating authorized robots",
      numApp: "Please enter the number of enterprise workstations",
      numPdfImage:
        "Please enter the documentation understands API quota (Pdf Image)",
      numPdfText:
        "Please enter the documentation understands API quota (Pdf Text)",
      numVicode: "Please enter the ViCode",
      privatization: "Please select the privatization deployment",
      systemAccount: "Please select the system account",
      deploymentWay: "Please select the deployment way",
    },
  },
};
